import { render, staticRenderFns } from "./DigitalCardQrcode.vue?vue&type=template&id=dc6812f8"
import script from "./DigitalCardQrcode.vue?vue&type=script&lang=js"
export * from "./DigitalCardQrcode.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/unique.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./DigitalCardQrcode.vue?vue&type=style&index=2&id=dc6812f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports